/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function EyeClosed(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M211.50122,129.23535a147.78919,147.78919,0,0,0,18.72144-19.333,7.99973,7.99973,0,0,0-12.44532-10.05468,128.72532,128.72532,0,0,1-21.28466,20.9541c-.05372.03808-.103.08008-.15528.11963A109.58952,109.58952,0,0,1,128,144a109.59068,109.59068,0,0,1-68.35156-23.08887c-.061-.04638-.11841-.0957-.18115-.14062A128.70627,128.70627,0,0,1,38.22168,99.84766a7.99972,7.99972,0,1,0-12.44531,10.05468,147.761,147.761,0,0,0,18.68188,19.29834l-19.49731,33.77a7.99959,7.99959,0,1,0,13.85547,8l18.49-32.02539a123.57956,123.57956,0,0,0,35.24438,16.28174l-5.81445,32.978a8.00124,8.00124,0,0,0,6.49023,9.26758,8.12,8.12,0,0,0,1.39844.12207,8.00272,8.00272,0,0,0,7.86914-6.61231l5.71729-32.42724a136.26072,136.26072,0,0,0,39.4873.01367l5.71826,32.42724a8.00278,8.00278,0,0,0,7.86914,6.61133,8.13106,8.13106,0,0,0,1.39942-.12207,8.00173,8.00173,0,0,0,6.48925-9.26855l-5.813-32.96436a123.56028,123.56028,0,0,0,35.28808-16.27832l18.38233,31.83838a7.99959,7.99959,0,0,0,13.85547-8Z" />
    </Svg>
  );
}

export default EyeClosed;
